import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// console.log(new Date().getFullYear())
// console.log(new Date().getMonth())

const article0={title:"《域见中国》发刊词",SecondTitle:"巨量引擎营销副总裁 陈都烨",date:"2020-9-8",shareTitle:"《域见中国》发刊词",shareDes:"区域发展迎来机遇爆发阶段\n洞察潮水方向，激发城市品牌力量"}

const article1={title:"城市名片打造的黄金路径",SecondTitle:"巨量引擎全国直营公司总经理 涂晴",date:"2020-9-8",shareTitle:"城市名片打造的黄金路径",shareDes:"厘清痛点，发掘创新玩法\n探索城市名片打造的黄金路径"}

// const article2={title:"对话操盘手_城市名片打造背后的短视频逻辑",SecondTitle:"厘清短视频传播对于城市品牌塑造的价值及路径，挖掘短视频打造城市名片的创意新思路",date:"2020-9-8",shareTitle:"对话操盘手_城市名片打造背后的短视频逻辑",shareDes:"厘清短视频传播对于城市品牌塑造的价值及路径，挖掘短视频打造城市名片的创意新思路"}
const article2={title:"对话操盘手_城市名片打造背后的短视频逻辑",SecondTitle:"为了厘清短视频传播对于城市品牌塑造的价值及路径，我们邀请到浙江省钱塘江文化研究会会长胡坚，中共湖州市委宣传部副部长、市委网信办主任陈建良等6位一线操盘手进行深度对话",date:"2020-9-8",shareTitle:"对话操盘手_城市名片打造背后的短视频逻辑",shareDes:"为了厘清短视频传播对于城市品牌塑造的价值及路径，我们邀请到浙江省钱塘江文化研究会会长胡坚，中共湖州市委宣传部副部长、市委网信办主任陈建良等6位一线操盘手进行深度对话"}

const article3={title:"参照标准缺位 城市短视频传播呼唤科学评估体系",SecondTitle:"清华大学国家形象传播研究中心主任  范红教授",date:"2020-9-8",shareTitle:"参照标准缺位 城市短视频传播呼唤科学评估体系",shareDes:"城市应该如何强化品牌传播效应？如何实现城市形象的测量与价值变现？又如何规避短视频传播过程中的可能风险？如何在更长远的层面促进城市与人的和谐发展……这一切问题都需要一个参照标准。"}

const article4={title:"短视频当兴，SIRFA模型构建城市线上传播风向标",SecondTitle:"",date:"2020-9-8",shareTitle:"短视频当兴，SIRFA模型构建城市线上传播风向标",shareDes:"在“云上传播”的2020年，SIRFA模型为城市带来“量化现状-补齐短板-综合提升”的城市营销新思路，展现出具备时代意义的指导价值"}

const article5={title:"城市名片打造方法论：五大策略构建城市线上繁荣",SecondTitle:"",date:"2020-9-8",shareTitle:"城市名片打造方法论：五大策略构建城市线上繁荣",shareDes:"从诸多成功案例中抖音归纳总结出五大方法论，且彼此联系形成一个完整的闭环，每个城市都可从方法论中探索适合自身的营销策略"}

const article6={title:"数读美好城市：2020年度十大美好城市榜单",SecondTitle:"",date:"2020-9-8",shareTitle:"数读美好城市：2020年度十大美好城市榜单",shareDes:"美好城市指数\n2020年度十大美好城市榜单"}

const article7={title:"打造“筑梦之城”，解锁光谷背后的整合营销路径",SecondTitle:"每个城市都不缺乏好故事，但我们缺乏讲好故事的形式和方式",date:"2020-9-8",shareTitle:"打造“筑梦之城”，解锁光谷背后的整合营销路径",shareDes:"每个城市都不缺乏好故事，但我们缺乏讲好故事的形式和方式"}

const article8={title:"借力IP营销，看江苏浦口如何打造“都市圈最美花园”名片",SecondTitle:"IP对城市形象传播的驱动价值是不可估量的，有效的运营能实现城市、平台、消费者三赢的局面",date:"2020-9-8",shareTitle:"借力IP营销，看江苏浦口如何打造“都市圈最美花园”名片",shareDes:"IP对城市形象传播的驱动价值是不可估量的，有效的运营能实现城市、平台、消费者三赢的局面"}

const article9={title:"钱塘江文化“云尚汇”亿级关注背后的故事",SecondTitle:"直播引爆+短视频沉淀，一场“永不落幕”的文化节！",date:"2020-9-8",shareTitle:"钱塘江文化“云尚汇”亿级关注背后的故事",shareDes:"直播引爆+短视频沉淀，一场“永不落幕”的文化节！"}

const article10={title:"深访5位百万粉丝创作者，我们总结出城市爆款短视频的四大法则",SecondTitle:"",date:"2020-9-8",shareTitle:"深访5位百万粉丝创作者，我们总结出城市爆款短视频的四大法则",shareDes:"总结出城市爆款短视频的四大原则"}

const article11={title:"城市繁荣形象是线上线下的数字孪生体现",SecondTitle:"中规院（北京）规划设计公司 城市研究专家 李昊",date:"2020-9-8",shareTitle:"城市繁荣形象是线上线下的数字孪生体现",shareDes:"思考人们在现实和数字世界交互中对城市的全新认知，对于在新时期探索理想城市的建设意义重大"}

const article12={title:"疫后复苏的城市品牌竞夺战 ：痛点与路径",SecondTitle:"执惠创始人兼CEO刘照慧",date:"2020-9-8",shareTitle:"疫后复苏的城市品牌竞夺战 ：痛点与路径",shareDes:"以抖音为代表的短视频强势介入，重塑了当前的城市营销、城市品牌传播与构建的渠道、路径、模式和价值评估体系。"}

const article13={title:"参照标准缺位 城市短视频传播呼唤科学评估体系",SecondTitle:"清华大学国家形象传播研究中心主任  范红教授",date:"2020-9-8",shareTitle:"参照标准缺位 城市短视频传播呼唤科学评估体系",shareDes:"城市应该如何强化品牌传播效应？如何实现城市形象的测量与价值变现？又如何规避短视频传播过程中的可能风险？如何在更长远的层面促进城市与人的和谐发展……这一切问题都需要一个参照标准。"}


export default new Vuex.Store({
  state:{
    DesignSize:{
      DesignWidth:1125,//设计宽度
      DesignHeight:1496,//设计高度
      SafeWidth:750,//安全区宽度
      SafeHeight:1206,//安全区高度
      // DesignWidth:1125,//设计宽度
      // DesignHeight:2304,//设计高度
      // SafeWidth:1125,//安全区宽度
      // SafeHeight:2304,//安全区高度
    },
    WindowSize:{
      WindowWidth:window.innerWidth,//屏幕宽度
      WindowHeight:window.innerHeight,//屏幕高度
      WindowWidthRem:window.innerWidth,//屏幕宽度
      WindowHeightRem:window.innerHeight,//屏幕高度
    },
    AutoPositon:{
      width:0,
      height:0,
      OffsetX:0,
      OffsetY:0,
      FontSize:0,
    },
    ArticleList:[
      article0,article1,article2,article3,article4,
      article5,article6,article7,article8,article9,
      article10,article11,article12,article13
    ],
    Banner1:[
      0,1,2
    ],
    List1:[
      13,4,5,6
    ],
    Banner2:[
      10
    ],
    List2:[
      12,11,3,10
    ],
    Banner3:[
    ],
    List3:[
      2,7,8,9
    ],
    thisClass:0,
    ArticleStack:[],
    ShareInfo:{
      title:"短视频与城市繁荣：打造城市金名片",
      desc: "《域见中国》首期 巨量引擎联动清华大学国家形象传播研究中心重磅推出",
      link: "https://www.primomedia.cn/m/oceanengine/oe_yujian/1st.html#/ArticleList",
      icon: "icon.jpg",
      count:0
    },
  },
  mutations: {
    SetWindowSize (state) {
      state.WindowSize.WindowWidth=window.innerWidth;
      state.WindowSize.WindowHeight=window.innerHeight;

      let WindowP=state.WindowSize.WindowWidth/state.WindowSize.WindowHeight;
      let SafeP=state.DesignSize.SafeWidth/state.DesignSize.SafeHeight;

      state.WindowSize.WindowWidthRem=state.DesignSize.DesignWidth/10;
      state.WindowSize.WindowHeightRem=state.WindowSize.WindowHeight/state.WindowSize.WindowWidth*state.DesignSize.DesignWidth/10;
      if(WindowP<SafeP){
        let p=state.WindowSize.WindowWidth/state.DesignSize.SafeWidth;
        state.AutoPositon.width=state.DesignSize.DesignWidth*p+'px';
        state.AutoPositon.height=state.DesignSize.DesignHeight*p+'px';
        state.AutoPositon.OffsetX=
          (state.DesignSize.SafeWidth-state.DesignSize.DesignWidth)/2*p+'px';
        state.AutoPositon.OffsetY=
          (state.WindowSize.WindowHeight-state.DesignSize.DesignHeight*p)/2+'px';
        state.AutoPositon.FontSize=
          10*p+'px';
      }else{
        let p=state.WindowSize.WindowHeight/state.DesignSize.SafeHeight;
        state.AutoPositon.width=state.DesignSize.DesignWidth*p+'px';
        state.AutoPositon.height=state.DesignSize.DesignHeight*p+'px';
        state.AutoPositon.OffsetX=
          (state.WindowSize.WindowWidth-state.DesignSize.DesignWidth*p)/2+'px';
        state.AutoPositon.OffsetY=
          (state.DesignSize.SafeHeight-state.DesignSize.DesignHeight)/2*p+'px';
        state.AutoPositon.FontSize=
          10*p+'px';
      }
      document.documentElement.style.fontSize=
        10*state.WindowSize.WindowWidth/state.DesignSize.DesignWidth+'px';
    },
    WindowSizeNoSet (state,id) {
      if(!id) id='app';
      state.WindowSize.WindowWidth=window.innerWidth;
      state.WindowSize.WindowHeight=window.innerHeight;
      let WindowP=state.WindowSize.WindowWidth/state.WindowSize.WindowHeight;
      let SafeP=state.DesignSize.SafeWidth/state.DesignSize.SafeHeight;
      if(WindowP>SafeP) {
        state.WindowSize.WindowWidth=SafeP*state.WindowSize.WindowHeight;
      }
      document.getElementById(id).style.transform='translateX('+(window.innerWidth-state.WindowSize.WindowWidth)/2+'px)'
      state.WindowSize.WindowWidthRem=state.DesignSize.DesignWidth/10;
      state.WindowSize.WindowHeightRem=state.WindowSize.WindowHeight/state.WindowSize.WindowWidth*state.DesignSize.DesignWidth/10;

      document.documentElement.style.fontSize=
        10*state.WindowSize.WindowWidth/state.DesignSize.DesignWidth+'px';
    },
    SetClass(state,thisClass){
      state.thisClass=thisClass
    },
    PushArticle(state,id){
      state.ArticleStack.push(id)
    },
    PopArticle(state){
      state.ArticleStack.pop()
    },
    ClearArticle(state){
      state.ArticleStack=[];
    },
    setShareInfo(state,info){
      state.ShareInfo=info;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/1st.js